"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMainMenuCharacterCreateUI = void 0;
const Class_1 = require("../../../classes/Class");
const retrommo_types_1 = require("retrommo-types");
const createCharacterSprite_1 = require("../components/createCharacterSprite");
const createImage_1 = require("../components/createImage");
const pixel_pigeon_1 = require("pixel-pigeon");
const createMainMenuCharacterCustomizeState_1 = require("../../state/main-menu/createMainMenuCharacterCustomizeState");
const createMainMenuCharacterSelectState_1 = require("../../state/main-menu/createMainMenuCharacterSelectState");
const createPanel_1 = require("../components/createPanel");
const createPressableButton_1 = require("../components/createPressableButton");
const definables_1 = require("definables");
const getMainMenuState_1 = require("../../state/main-menu/getMainMenuState");
const state_1 = require("../../../state");
const createMainMenuCharacterCreateUI = () => {
    const condition = () => state_1.state.values.mainMenuState !== null &&
        state_1.state.values.mainMenuState.values.characterCreateState !== null;
    // Background panel
    (0, createPanel_1.createPanel)({
        condition,
        height: (0, pixel_pigeon_1.getGameHeight)(),
        imagePath: "panels/basic",
        width: (0, pixel_pigeon_1.getGameWidth)(),
        x: 0,
        y: 0,
    });
    // Back arrow
    (0, createImage_1.createImage)({
        condition,
        height: 14,
        imagePath: "arrows/left",
        onClick: () => {
            (0, getMainMenuState_1.getMainMenuState)().setValues({
                characterCreateState: null,
                characterSelectState: (0, createMainMenuCharacterSelectState_1.createMainMenuCharacterSelectState)({ page: 0 }),
            });
        },
        width: 14,
        x: 16,
        y: 16,
    });
    // Title text
    (0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition,
            x: (0, pixel_pigeon_1.getGameWidth)() / 2,
            y: 10,
        },
        horizontalAlignment: "center",
        size: 2,
        text: { value: "Character Creation" },
    });
    const classes = Array.from((0, definables_1.getDefinables)(Class_1.Class));
    const sortedClasses = classes.sort(([, a], [, b]) => a.order - b.order);
    sortedClasses.forEach(([, sortedClass], sortedClassIndex) => {
        // Class panel
        (0, createPanel_1.createPanel)({
            condition,
            height: 80,
            imagePath: "panels/basic",
            width: 80,
            x: 16 + sortedClassIndex * 96,
            y: 48,
        });
        // Class name text
        (0, pixel_pigeon_1.createLabel)({
            color: retrommo_types_1.Color.White,
            coordinates: {
                condition,
                x: 56 + sortedClassIndex * 96,
                y: 57,
            },
            horizontalAlignment: "center",
            size: 1,
            text: { value: sortedClass.name },
        });
        // Class player sprite
        (0, createCharacterSprite_1.createCharacterSprite)({
            clothesDyeID: sortedClass.defaultClothesDyeItem.clothesDyeID,
            coordinates: {
                condition,
                isAnimated: true,
                x: 48 + sortedClassIndex * 96,
                y: 74,
            },
            direction: retrommo_types_1.Direction.Down,
            figureID: sortedClass.defaultFigureID,
            hairDyeID: sortedClass.defaultHairDyeItem.hairDyeID,
            maskID: sortedClass.defaultMaskItem.maskID,
            outfitID: sortedClass.defaultOutfitItem.outfitID,
            skinColorID: sortedClass.defaultSkinColorID,
        });
        // Select button
        (0, createPressableButton_1.createPressableButton)({
            condition,
            height: 16,
            imagePath: "pressable-buttons/gray",
            onClick: () => {
                (0, getMainMenuState_1.getMainMenuState)().setValues({
                    characterCreateState: null,
                    characterCustomizeState: (0, createMainMenuCharacterCustomizeState_1.createMainMenuCharacterCustomizeState)({
                        classID: sortedClass.id,
                    }),
                });
            },
            text: { value: "Select" },
            width: 44,
            x: 34 + sortedClassIndex * 96,
            y: 103,
        });
    });
};
exports.createMainMenuCharacterCreateUI = createMainMenuCharacterCreateUI;
